import { useEffect } from 'react'

// Wave Final (P0-12): единая фабрика WebSocket-соединений.
// 1. Базу URL берём из REACT_APP_WS_URL (или fallback wss://sys.chu.kg).
// 2. Прикладываем JWT через ?token=... — backend `TokenAuthMiddleware`
//    распарсит query, как и в случае HTTP-Authorization-header.
//    После того как backend перейдёт на httpOnly-cookie — этот блок
//    переключаем на отсутствие явного токена (cookie уйдёт автоматом).
//
// Использование:
//   const ws = createWS('/ws/notifications/')           // прод-готов
//   const ws = createWS('/ws/online_status/', { skipAuth: true }) // публичный
//
// 13 ручных `new WebSocket('wss://sys.chu.kg/...')` в проекте должны
// постепенно мигрировать на эту фабрику.

const DEFAULT_WS_BASE = 'wss://sys.chu.kg'

export function getWsBaseUrl() {
  const fromEnv = process.env.REACT_APP_WS_URL
  if (fromEnv) return fromEnv.replace(/\/+$/, '')
  return DEFAULT_WS_BASE
}

export function buildWsUrl(path, { skipAuth = false } = {}) {
  const base = getWsBaseUrl()
  const cleanPath = path.startsWith('/') ? path : `/${path}`
  const url = `${base}${cleanPath}`
  if (skipAuth) return url
  const token = (() => {
    try {
      return localStorage.getItem('token')
    } catch {
      return null
    }
  })()
  if (!token) return url
  const sep = url.includes('?') ? '&' : '?'
  return `${url}${sep}token=${encodeURIComponent(token)}`
}

export function createWS(path, options = {}) {
  return new WebSocket(buildWsUrl(path, options))
}

const WebSocketComponent = ({
  url,
  onOpen,
  onClose,
  onError,
  onMessage,
  setSocket,
}) => {
  useEffect(() => {
    const socket = new WebSocket(url)
    socket.addEventListener('open', onOpen)
    socket.addEventListener('close', onClose)
    socket.addEventListener('error', onError)
    socket.addEventListener('message', onMessage)

    setSocket(socket)

    return () => {
      socket.close()
    }
  }, [url, onOpen, onClose, onError, onMessage, setSocket])

  return null
}

export default WebSocketComponent
